export default __webpack_public_path__ + "hero-c86b8a1eb21e9390407dd164f66c541e.digested.webp";